import * as React from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    Switch,
} from "@mui/material";
import {useTranslation} from "react-i18next";
import {ApprovedJobOption} from "../../../../hooks/useJobPositions";

export interface AddJobPositionDialogProps {
    open: boolean;
    addJobId: string;
    setAddJobId: (id: string) => void;
    addActive: boolean;
    setAddActive: (active: boolean) => void;
    approvedJobOptions: ApprovedJobOption[];
    approvedJobsLoading: boolean;
    onClose: () => void;
    onSave: () => void;
}

export default function AddJobPositionDialog({
    open,
    addJobId,
    setAddJobId,
    addActive,
    setAddActive,
    approvedJobOptions,
    approvedJobsLoading,
    onClose,
    onSave,
}: Readonly<AddJobPositionDialogProps>): React.ReactElement {
    const {t} = useTranslation();
    return (
        <Dialog
            open={open}
            onClose={(_event, reason) => {
                if (reason === "backdropClick") return;
                onClose();
            }}
            disableEscapeKeyDown
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>{t('hr.jobs.assignToBranch.button')}</DialogTitle>
            <DialogContent>
                <Box sx={{display: "flex", flexDirection: "column", gap: 2, mt: 1}}>
                    <FormControl size="small" fullWidth required>
                        <InputLabel id="add-job-label">{t('hr.jobs.dialog.jobPositionLabel')}</InputLabel>
                        <Select
                            labelId="add-job-label"
                            label={t('hr.jobs.dialog.jobPositionLabel')}
                            value={addJobId}
                            onChange={(e) => setAddJobId(e.target.value)}
                            disabled={approvedJobsLoading}
                        >
                            {approvedJobsLoading ? (
                                <MenuItem disabled value="">{t('common.loading')}</MenuItem>
                            ) : approvedJobOptions.length === 0 ? (
                                <MenuItem disabled value="">{t('hr.jobs.dialog.noApprovedOptions')}</MenuItem>
                            ) : (
                                approvedJobOptions.map((j) => (
                                    <MenuItem key={j.id} value={j.id}>{j.name}</MenuItem>
                                ))
                            )}
                        </Select>
                    </FormControl>
                    <FormControlLabel
                        control={<Switch checked={addActive} onChange={(e) => setAddActive(e.target.checked)}
                                         color="primary"/>}
                        label={t('common.status.active')}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('common.actions.cancel')}</Button>
                <Button variant="contained" onClick={onSave}
                        disabled={!addJobId || approvedJobsLoading}>{t('common.actions.save')}</Button>
            </DialogActions>
        </Dialog>
    );
}
